<template>
  <div class="row g-4">
    <!-- Client Information -->
    <div class="col-lg-4 col-md-6">
      <div class="card border-0 shadow-sm rounded-3 h-100">
        <div
          class="card-header bg-primary text-white d-flex align-items-center"
        >
          <i class="bi bi-person-circle fs-4 me-2"></i>
          <h5 class="mb-0 fs-16 fw-semibold">Informations Client</h5>
        </div>
        <div class="card-body">
          <ul class="list-unstyled mb-0">
            <li class="mb-3">
              <small class="text-muted text-uppercase">Magasin</small><br />
              <span class="fw-semibold">{{
                colisRow?.client?.store ?? colisRow.customer_name
              }}</span>
            </li>
            <li class="mb-3">
              <small class="text-muted text-uppercase">Client</small><br />
              <span class="fw-semibold">{{ colisRow?.client?.store }}</span>
            </li>
            <li>
              <small class="text-muted text-uppercase">Téléphone</small><br />
              <a
                :href="`tel:${colisRow?.client?.phone}`"
                class="text-decoration-none text-dark fw-semibold"
              >
                {{ colisRow?.client?.phone }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Parcel Information -->
    <div class="col-lg-8 col-md-6">
      <div class="card border-0 shadow-sm rounded-3 h-100">
        <div
          class="card-header bg-success text-white d-flex align-items-center"
        >
          <i class="bi bi-box-seam fs-4 me-2"></i>
          <h5 class="mb-0 fs-16 fw-semibold">Informations Colis</h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-sm-6">
              <small class="text-muted text-uppercase">Code d'envoi</small
              ><br />
              <span class="fw-semibold">{{ colisRow.code }}</span>
            </div>
            <div class="col-sm-6">
              <small class="text-muted text-uppercase">Destinataire</small
              ><br />
              <span class="fw-semibold">{{ colisRow.receiver }}</span>
            </div>
            <div class="col-sm-6">
              <small class="text-muted text-uppercase">Téléphone</small><br />
              <a
                :href="`tel:${colisRow.phone}`"
                class="text-decoration-none text-dark fw-semibold"
              >
                {{ colisRow.phone }}
              </a>
            </div>
            <div class="col-sm-6">
              <small class="text-muted text-uppercase">Ville</small><br />
              <span class="fw-semibold">{{ colisRow.city_name }}</span>
            </div>
            <div class="col-12">
              <small class="text-muted text-uppercase">Adresse</small><br />
              <span class="fw-semibold">{{ colisRow.adresse }}</span>
            </div>
            <div class="col-12">
              <small class="text-muted text-uppercase">Commentaire</small><br />
              <span class="fw-semibold">{{ colisRow.note }}</span>
            </div>
            <div class="col-sm-6">
              <small class="text-muted text-uppercase">Nature Produit</small
              ><br />
              <span class="fw-semibold">{{ colisRow.product_nature }}</span>
            </div>
            <div class="col-sm-6">
              <small class="text-muted text-uppercase">Crbt</small><br />
              <span class="fw-bold text-success">{{ colisRow.price }} {{ $devis }}</span>
            </div>
            <div v-if="isFromStock" class="col-12">
              <span class="badge bg-warning text-dark">
                <i class="bi bi-box"></i> Colis de Stock
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product List (stock parcels only) -->
    <div v-if="isFromStock" class="col-12">
      <div class="card border-0 shadow-sm rounded-3">
        <div
          class="card-header bg-primary text-white d-flex align-items-center"
        >
          <i class="bi bi-bag-check fs-4 me-2"></i>
          <h5 class="mb-0 fs-16 fw-semibold">Produits</h5>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table align-middle mb-0">
              <thead class="bg-light">
                <tr>
                  <th></th>
                  <th>Produit</th>
                  <th>Informations</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="productsLoading">
                  <td colspan="3" class="text-center text-muted py-3">
                    <span class="spinner-border spinner-border-sm me-5"></span>
                    Chargement...
                  </td>
                </tr>
                <tr v-else-if="!products.length">
                  <td colspan="3" class="text-center text-muted py-3">
                    Aucun produit.
                  </td>
                </tr>
                <tr
                  v-for="(product, index) in products"
                  :key="index"
                  class="border-bottom"
                >
                  <td>
                    <img
                      :src="
                        product.product_pic ||
                        require('@/assets/images/NoImage.png')
                      "
                      width="60"
                      height="60"
                      class="rounded-2 border"
                    />
                  </td>
                  <td>
                    <div class="fw-semibold">{{ product.product_name }}</div>
                    <small class="text-muted"
                      >{{ product.variant_name }} -
                      {{ product.variant_ref }}</small
                    >
                  </td>
                  <td>
                    <small class="d-block"
                      ><b>Quantité :</b> {{ product.qnty }}</small
                    >
                    <small class="text-muted"
                      ><b>Date :</b> {{ getDate(product.created_at) }}</small
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import api from "@/utils/axios";
import { onMounted, ref } from "vue";
import { computed, watch } from "vue";
export default {
  name: "HistoryColis",

  props: {
    coliDetails: {
      type: Object,
      required: true,
    },

    isOpen: {
      type: Boolean,
    },
  },

  setup: (props) => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const colisRow = ref<any>({});
    const products = ref<any[]>([]);
    const productsLoading = ref(false);

    const isFromStock = computed(() => Number(colisRow.value?.from_stock) === 1);

    // the list row doesn't carry the parcel content, fetch it (colis_contents)
    async function getProducts() {
      products.value = [];
      if (!isFromStock.value || !colisRow.value?.id) return;
      productsLoading.value = true;
      try {
        const res = await api.get("/api/auth/ProductColis", {
          params: { colis_id: colisRow.value.id, cstmr_id: colisRow.value.customer },
        });
        products.value = res.data;
      } catch (error) {
        console.error("Error fetching parcel products:", error);
      } finally {
        productsLoading.value = false;
      }
    }

    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH : mm");
    }

    const isReady = computed(() => {
      return (
        props.isOpen &&
        props.coliDetails &&
        typeof props.coliDetails === "object" &&
        Object.keys(props.coliDetails).length > 0
      );
    });

    onMounted(() => {
      console.log("isOpen:", props.isOpen);
      if (props.isOpen) {
        colisRow.value = props.coliDetails;
      }
    });
    watch(
      isReady,
      (ready) => {
        if (ready) {
          console.log("Modal opened with coliDetails:", props.coliDetails);
          // fetch or process data here
          colisRow.value = props.coliDetails;
          getProducts();
        }
      },
      { immediate: true }
    );

    return {
      colisRow,
      products,
      productsLoading,
      isFromStock,
      getDate,
    };
  },
};
</script>